/** Fase 2 (W6, L12 e L13): tipos das telas de Serviços, Formas e Condições de pagamento. */
export const USOS_SERVICO = ['venda', 'compra', 'ambos'] as const;
export const TIPOS_COBRANCA = ['recorrente', 'avulso'] as const;
export const TIPOS_FORMA = ['pix', 'boleto', 'transferencia', 'cartao_credito', 'cartao_debito', 'dinheiro', 'cheque', 'outro'] as const;

export interface ServicoCatalogo {
  id: string;
  nome: string;
  codigo: string | null;
  descricao: string | null;
  uso: (typeof USOS_SERVICO)[number];
  agendavel: boolean;
  preco_venda_centavos: number;
  custo_centavos: number;
  moeda: string;
  tipo_cobranca: (typeof TIPOS_COBRANCA)[number];
  centro_custo_padrao_id: string | null;
  categoria_padrao_id: string | null;
  ativo: boolean;
  extras: Record<string, unknown>;
  /** Fase 2 (W18, K2): duração na Agenda (nula = 60 min) e quem faz (vazio = qualquer recurso). */
  duracao_min: number | null;
  recurso_ids: string[];
}

export interface FormaPagamento {
  id: string;
  nome: string;
  tipo: (typeof TIPOS_FORMA)[number];
  abreviatura: string | null;
  descricao: string | null;
  ativa: boolean;
  /** Fase 2 (W19, K5): campos personalizados. */
  extras?: Record<string, unknown>;
}

export interface CondicaoPagamento {
  id: string;
  nome: string;
  codigo: string;
  ativa: boolean;
  extras?: Record<string, unknown>;
}

/** Prazos em dias do código da condição (`avista` é [0]; o servidor já validou a ordem). */
export function prazosDaCondicao(codigo: string): number[] {
  return codigo === 'avista' ? [0] : codigo.split('/').map(Number).filter((n) => Number.isFinite(n));
}

/** Fase 2 (W31, 5.2): serviço contratado de terceiros (Cadastros > Serviços > Serviços). */
export interface ServicoContratado {
  id: string;
  nome: string;
  descricao: string | null;
  categoria_despesa_id: string | null;
  fornecedor_padrao_id: string | null;
  fornecedor_nome: string | null;
  /** Lote 09/10 (B2): valor de referência em centavos (a compra sugere no item). */
  valor_referencia_centavos: number | null;
  ativo: boolean;
}
